import type { ReactNode } from 'react';

export const symbol_accessible_menu: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M428.5-755.42q-21.5-21.42-21.5-51.5t21.42-51.58q21.42-21.5 51.5-21.5t51.58 21.42q21.5 21.42 21.5 51.5t-21.42 51.58q-21.42 21.5-51.5 21.5t-51.58-21.42ZM373-120v-493q-78-6-139-15t-114-22l15-60q78 19 163 28t182 9q97 0 182-9t163-28l15 60q-53 13-114 22t-139 15.16V-120h-60v-260h-94v260h-60Zm402-338.89q-11-10.9-11-27Q764-502 774.89-513q10.9-11 27-11Q818-524 829-513.11q11 10.9 11 27Q840-470 829.11-459q-10.9 11-27 11Q786-448 775-458.89Zm0 164q-11-10.9-11-27Q764-338 774.89-349q10.9-11 27-11Q818-360 829-349.11q11 10.9 11 27Q840-306 829.11-295q-10.9 11-27 11Q786-284 775-294.89Zm0 164q-11-10.9-11-27Q764-174 774.89-185q10.9-11 27-11Q818-196 829-185.11q11 10.9 11 27Q840-142 829.11-131q-10.9 11-27 11Q786-120 775-130.89Z"
		/>
	</svg>
);
